import React, { useState } from "react"
import "./PropertyCard.scss"
import { Row } from "react-bootstrap"
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image"
import imageConfig from "../../../static/images/config.json"
import NoImage from "../../images/no-image.png"
import { Link } from "gatsby"
import $ from "jquery"
const PropertyCard = ({
  propertyid,
  status,
  gridview,
  price,
  priceQualifier,
  title,
  location,
  description,
  bedroomsCount,
  receptionsCount,
  bathroomsCount,
  floorarea,
  floorarea_type,
  propertyVideo,
  propertyImages,
  propertyDetailsLink,
  propertySearchType,
  noResulttag,
  userObjects,
  savedSearchParams,
}) => {
    //property description
    let text_truncate = function (str, length, ending) {
      if ($(window).width() > 1400) {
        length = 220
      } else {
        length = 160
      }
      //
      if (ending == null) {
        ending = "... "
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending
      } else {
        return str
      }
    }
    //var propertyintro = removeTags(description);
    var propertyintro = description && description.replace(/\<br\>/g, " ")
    //property description
  var propertystatus= ""
  if(status == "sold" || status == "sold-stc" || status == "let-agreed") {
    propertystatus = "true";
  }
  return (
    <div className={`property-item-wrapper ${gridview ? "grid-view-wrapper" : ""}`} id={`property_detail_${propertyid}`}>
      <div className="property-item__row">
        <div className="property-item__row-inner">
          <div className="property-item__gallery d-md-grid">
            {propertyImages && propertyImages.length > 0 ? (
              <div className="featured-image img-zoom">
                {propertystatus == "true" ?
                <div className="pstatus">
                {(status == "sold" ) ? "Sold" : (status == "sold-stc") ? "Sold STC" : (status == "let-agreed") ? "Let Agreed" : ""}
                </div> : "" }
                <picture>
                  <Link to={propertyDetailsLink}>
                    {noResulttag === "noResultsProperty" ? (
                        <picture>
                          <img
                            src={propertyImages && propertyImages[0]?.url}
                            alt={location + " - David Astburys"}
                          />
                        </picture>
                    ) : (
                      <ShowProcessedImage
                        images={propertyImages && propertyImages[0]}
                        attr={{
                          className: "mb-0 img-fluid",
                          alt: location + " - David Astburys",
                        }}
                        transforms={imageConfig.property.searchResults.sizes}
                      />
                    )}
                  </Link>
                </picture>
                {/* <Link className="btn-link" to={propertyDetailsLink}>
                  <i class="icon icon-track-slider-link-arrow"></i>
                </Link> */}
              </div>
            ) : (
              <div className="featured-image img-zoom">
                <picture>
                  <Link to={propertyDetailsLink}>
                    <img src={NoImage} alt={location + " - David Astburys"} />
                  </Link>
                </picture>
                {/* <Link className="btn-link" to={propertyDetailsLink}>
                  <i class="icon icon-track-slider-link-arrow"></i>
                </Link> */}
              </div>
            )}
          </div>
        </div>
        <div className="property-item__text">
            <div className="property-text-inner">
            {
              propertySearchType === "sales" ? 
              <>
                <h4>{priceQualifier}</h4> 
                <h2>{price}</h2>
              </>
              : 
              <>
              <h4>{priceQualifier === "Weekly" ? "per week" : (priceQualifier === "Monthly" ? "per month" : priceQualifier) }</h4>
              <h2>{price} </h2>
              </>
            }   
            <Link to={propertyDetailsLink}>
              <h3>{location}</h3>
            </Link>       
            <div className="property-icons">
              {bedroomsCount != 0 &&
              <div>
                <i className="icon-bedroom-list"></i>{bedroomsCount}
              </div>
              }
              {bathroomsCount != 0 &&
              <div>
                <i className="icon-bathroom-list"></i>{bathroomsCount}
              </div>
              }
              {receptionsCount != 0 &&
              <div>
                <i className="icon-reception-list"></i>{receptionsCount}
              </div>
              }
              {floorarea !=0 &&
              <div>
                <i className="icon-size-list"></i>{Math.round(floorarea)}{` ${floorarea_type}`}
              </div>
              }
            </div>
            {gridview == false && description ?
            <div className="property-item__description">
              <p>
                {text_truncate(propertyintro)}
              </p>
            </div>
            : "" }
            {gridview == false ?
            <div className="property-actions">
              <Link to={propertyDetailsLink}>View Details</Link>              
            </div>
            :"" }
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyCard

